import React from 'react';

function ProductImageSection({ src, alt }) {
  return (
    <section className="product-image-section">
      <img src={src} alt={alt} className="product-image" />
    </section>
  );
}

export default ProductImageSection;
